import React from 'react';
import dynamic from 'next/dynamic';
import Box from '@firsttable/web-components/atoms/Box';
import PropTypes from 'prop-types';
import birdBookingSvg from './assets/bird-booking.svg?url';

const LoadingSvg = ({ width, height, style = {} }) => (
  <img src={birdBookingSvg} alt="Loading" width={width} height={height} style={style} />
);

LoadingSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
};

const Animation = dynamic(() => import('./Animation'), {
  ssr: false,
  // Use a static SVG while the Lottie library and Bird Booking animation are loading
  loading: () => <LoadingSvg width={130} height={130} style={{ position: 'relative' }} />,
});

const PageLoading = (props) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    width={120}
    height={120}
    position="relative"
    mx="auto"
    {...props}>
    <Animation width="100%" height="100%" />
  </Box>
);

export default PageLoading;
